import InputAdornment from '@mui/material/InputAdornment';
import React from 'react';
import moment from 'moment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';

interface IMDatePickerProps {
  label: string;
  value?: string;
  icon?: React.ReactElement;
  disabled?: boolean;
  onChange: (string: any) => void;
  disablePast?: boolean;
  format?: string;
  haveMaxDate?: boolean;
  haveMinDate?: boolean;
  maxDate?: moment.Moment;
  minDate?: moment.Moment;
  disableFuture?: boolean;
}

const MDatePicker: React.FunctionComponent<IMDatePickerProps> = ({
  label,
  value,
  icon,
  disabled,
  onChange,
  disablePast,
  format,
  haveMinDate = false,
  minDate = moment(),
  haveMaxDate = true,
  maxDate = moment().add(30, 'days'),
  disableFuture,
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DemoContainer components={['MobileDateTimePicker']}>
        <MobileDateTimePicker
          className="date-time-picker text-field"
          label={label}
          disabled={disabled}
          value={moment(value, 'DD-MM-YYYY H:mm')}
          format={format ?? 'DD-MM-YYYY H:mm'}
          maxDate={haveMaxDate ? maxDate : undefined}
          minDate={haveMinDate ? minDate : undefined}
          onChange={(newValue) => {
            onChange(newValue ? newValue.toDate() : moment().toDate());
          }}
          sx={{
            minWidth: '100% !important',
            fontSize: 'small',
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                border: 'none',
                borderColor: 'transparent',
                borderRadius: '0px !important',
                borderBottom: '1px solid gray !important',
              },
              '&:hover fieldset': {
                border: 'none',
                borderColor: 'transparent',
                borderRadius: '0px !important',
                borderBottom: '1px solid #0b67c3 !important',
              },
              '&.Mui-focused fieldset': {
                border: 'none',
                borderColor: 'transparent',
                borderRadius: '0px !important',
                borderBottom: '1px solid #0b67c3 !important',
              },
            },
          }}
          slotProps={{
            textField: {
              InputProps: {
                endAdornment: (
                  <InputAdornment position="end">{icon}</InputAdornment>
                ),
              },
            },
          }}
          disablePast={disablePast}
          disableFuture={disableFuture}
        />
      </DemoContainer>
    </LocalizationProvider>
  );
};

export default MDatePicker;
